export const AutomaticFeeChangeTagTestIds = {
  TAG: 'automatic-fee-change.tag',
};
